import type React from "react"

interface Props {
  checkinTime: string
  checkoutTime: string | null
  checkInDate: string | null
  checkOutDate: string | null
}

const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
)

const LoginIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="10 17 15 12 10 7" />
    <line x1="15" y1="12" x2="3" y2="12" />
  </svg>
)

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
)

function formatDate(iso: string): string {
  try {
    const d = new Date(iso)
    return d.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" })
  } catch {
    return iso
  }
}

export function StayTimeline({ checkinTime, checkoutTime, checkInDate, checkOutDate }: Props) {
  const rows: { icon: () => React.ReactElement; label: string; value: string; note?: string }[] = []

  if (checkInDate) {
    rows.push({ icon: CalendarIcon, label: "Arrival", value: formatDate(checkInDate) })
  }

  rows.push({
    icon: LoginIcon,
    label: "Check-in",
    value: checkinTime || "15:00",
  })

  if (checkoutTime) {
    rows.push({
      icon: LogoutIcon,
      label: "Check-out",
      value: checkoutTime,
    })
  }

  if (checkOutDate) {
    rows.push({ icon: CalendarIcon, label: "Departure", value: formatDate(checkOutDate) })
  }

  if (rows.length === 0) return null

  return (
    <div className="gc-card gc-card--divided gc-timeline">
      {rows.map(({ icon: Icon, label, value, note }) => (
        <div key={label} className="gc-timeline-row">
          <div className="gc-timeline-icon"><Icon /></div>
          <div>
            <div className="gc-timeline-label">{label}</div>
            <div className="gc-timeline-value">{value}</div>
            {note && <div className="gc-timeline-note">{note}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}
